import { createContext } from 'react';
import { useSelector } from 'react-redux';
import Me from '@models/Me';
import PropTypes from 'prop-types';

export const Context = createContext();

export const PurchaseTypeContextProvider = ({ children, goalUID }) => {
  const latestUserSubscriptions = useSelector(
    ({ auth }) => auth.me?.latestUserSubscriptions || []
  );
  const subscription = Me.getSubscription(latestUserSubscriptions, goalUID);

  // eslint-disable-next-line no-nested-ternary
  const purchaseType = subscription
    ? subscription.time_remaining
      ? 'extension'
      : 'renewal'
    : 'new';

  return <Context.Provider value={purchaseType}>{children}</Context.Provider>;
};

PurchaseTypeContextProvider.defaultProps = {
  goalUID: ''
};

PurchaseTypeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  goalUID: PropTypes.string
};

PurchaseTypeContextProvider.defaultProps = {
  goalUID: ''
};
